import { useEffect } from 'react';

const isMac = typeof navigator !== 'undefined'
  && /Mac|iPhone|iPad/.test(navigator.platform || navigator.userAgent);

/** Meta/Ctrl + key; ignored while another dialog already owns the keyboard (except the palette/ask toggles). */
export function useMetaShortcut(key: string, onTrigger: () => void) {
  useEffect(() => {
    const onKey = (event: KeyboardEvent) => {
      if (event.key.toLowerCase() !== key.toLowerCase() || !(event.metaKey || event.ctrlKey) || event.altKey || event.shiftKey) return;
      event.preventDefault();
      onTrigger();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [key, onTrigger]);
}

/** @deprecated Prefer useMetaShortcut('k', …) for the palette. Kept for older imports. */
export function useCommandKey(toggle: () => void) {
  useMetaShortcut('k', toggle);
}

/** ⌘K / Ctrl K — command palette. */
export const paletteShortcutLabel = isMac ? '⌘K' : 'Ctrl K';
/** ⌘J / Ctrl J — Ask or tell the agent. */
export const askShortcutLabel = isMac ? '⌘J' : 'Ctrl J';
/** Alias used by the top-bar Ask button before the palette split. */
export const shortcutLabel = askShortcutLabel;
